import { createContext } from 'react';

import { TenantFeatureSubscriptions } from '../hooks/tenant-feature-subscriptions';

const TenantFeatureSubscriptionsProviderContext = createContext<TenantFeatureSubscriptions>({} as TenantFeatureSubscriptions);

export default TenantFeatureSubscriptionsProviderContext;
